import React, { useRef } from 'react';
import { MdCalendarToday } from 'react-icons/md';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import './DatePicker.css';

function DatePicker({ value, onChange, label, required = false, hasError = false }) {
  const inputRef = useRef(null);

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker?.();
    }
  };

  const formatDisplayDate = (dateString) => {
    if (!dateString) return 'Selecione uma data';
    try {
      // Remover timestamp se houver
      const cleanDate = dateString.includes('T') ? dateString.split('T')[0] : dateString;
      // Garantir que temos uma data válida no formato YYYY-MM-DD
      if (!/^\d{4}-\d{2}-\d{2}$/.test(cleanDate)) {
        return 'Selecione uma data';
      }
      const date = new Date(cleanDate + 'T00:00:00');
      if (isNaN(date.getTime())) {
        return 'Selecione uma data';
      }
      return format(date, "dd/MM/yyyy", { locale: ptBR });
    } catch {
      return 'Selecione uma data';
    }
  };

  return (
    <div className="datepicker-wrapper">
      {label && (
        <label className="datepicker-label">
          {label}
          {required && <span className="required-mark">*</span>}
        </label>
      )}
      
      <div className={`datepicker-container ${hasError ? 'error' : ''}`} onClick={handleClick}>
        <MdCalendarToday size={20} className="datepicker-icon" />
        <div className="datepicker-display">
          {formatDisplayDate(value)}
        </div>
        <input
          ref={inputRef}
          type="date"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          className="datepicker-input"
        />
        <MdCalendarToday size={18} className="datepicker-arrow" />
      </div>
    </div>
  );
}

export default DatePicker;
